











































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AxDockButton extends Vue {
  @Prop({ type: Boolean, default: false })
  addDisabled!: boolean;

  @Prop({ type: Boolean, default: false })
  removeDisabled!: boolean;

  onAddClicked() {
    this.$emit('add');
  }

  onRemoveClicked() {
    this.$emit('remove');
  }
}
